import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { routes } from './App'
import { verificationEntryPath } from './lib/verificationHost'
import './styles/index.css'

const container = document.getElementById('root')
if (!container) throw new Error('No #root element to mount into')

// Before the router reads the URL, not after. A redirect performed once the router is up
// renders the application root first - which for somebody with no ARMS account is a flash
// of a sign-in screen on their way to a page that never needed one.
const entry = verificationEntryPath(window.location.host, window.location.pathname)
if (entry) window.history.replaceState(null, '', entry)

// A data router, not <BrowserRouter>. Only this kind hands useBlocker a navigation to
// intercept, which is what lets a detail page stop somebody leaving unsaved work behind.
createRoot(container).render(
  <StrictMode>
    <RouterProvider router={createBrowserRouter(routes)} />
  </StrictMode>,
)
